import { createGlobalStyle } from "styled-components";

export const AppContainerStyle = createGlobalStyle`
.app-container{
  height: auto;
}
`